import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { FeedbackRequest } from '../shared/models/request/feedback-request.model';
import { FeedbackResponse } from '../shared/models/response/feedback-response.model';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  readonly #urlApiManagement = environment.urlApiManagement;

  readonly #http = inject(HttpClient);

  createFeedback(params: FeedbackRequest): Observable<FeedbackResponse> {
    const url = `${this.#urlApiManagement}/api/v1/feedbacks`;
    return this.#http.post<FeedbackResponse>(url, params);
  }
}
